import { useInView } from '~/hooks/use-in-view';
import { AttachmentsCarousel, type CarouselItemData } from '~/modules/attachment/attachments-carousel';
import { DeviceFrame } from '~/modules/marketing/device-mockup-frame';
import { useUIStore } from '~/modules/ui/ui-store';
import { cn } from '~/utils/cn';

type DeviceType = 'mobile' | 'tablet' | 'pc';
type MockupItem = Pick<CarouselItemData, 'url' | 'id' | 'name'>;

interface DeviceMockupProps {
  lightItems?: MockupItem[];
  darkItems?: MockupItem[];
  className?: string;
  type: DeviceType;
}

export function DeviceMockup({ lightItems, darkItems, type, className }: DeviceMockupProps) {
  const mode = useUIStore((state) => state.mode);

  const items = mode === 'dark' ? darkItems : lightItems;

  const { ref, inView } = useInView();
  const mockupClass = cn('transition-opacity duration-700 ease-out', inView ? 'opacity-100' : 'opacity-0');

  return (
    <div className={cn(mockupClass, className)} ref={ref}>
      <DeviceFrame
        type={type}
        inView={inView}
        renderCarousel={(className) => {
          return <AttachmentsCarousel items={items || []} isDialog={false} classNameContainer={className} />;
        }}
      />
    </div>
  );
}
